<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle" :info="info" :validation="validation">
		<VueNumberFormat
				:id="inputId"
				:value="modelValue"
				v-model:value="inputValue"
				@keyup="emitInput"
				class="form-control"
				:class="{'is-invalid': validation?.$error}"
				:placeholder="placeholder"
				v-focus="focus"
				autocomplete="off"
				:options="{ precision: precision, acceptNegative: acceptNegative }"></VueNumberFormat>
	</LayoutFormInputGeneral>
</template>

<script>
	import { ref } from 'vue';

	export default {
		emits: ['update:modelValue'],
		props: {
			modelValue: Number,
			title: String,
			subtitle: String,
			info: String,
			placeholder: String,
			validation: Object,
			precision: {
				type: Number,
				default: 2
			},
			focus: {
				type: Boolean,
				default: false
			},
			acceptNegative: {
				type: Boolean,
				default: false
			}
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const inputValue = ref(props.modelValue);

			const emitInput = () => {
				emit('update:modelValue', (inputValue.value > 0) ? inputValue.value : null);
			};

			return { inputId, inputValue, emitInput };
		}
	}
</script>